import React from 'react';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import PropTypes from 'prop-types';
const AmbassadorIcon = ({ size = 14 }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #F7B737 50%, #F9CF58 100%)",
        borderRadius: 3,
        height: `${size}px`,
        width: `${size}px`,
      }}
    >
      <StarRoundedIcon
        fill="white"
        style={{ color: "white", fontSize: `${size * 0.57}px` }}
      />
    </div>
  );
};

export default AmbassadorIcon;

AmbassadorIcon.propTypes = {
  size: PropTypes.number,
};
